import {DefaultFooter} from '@ant-design/pro-components';
import {useIntl} from "@umijs/max";
import React from 'react';

const Footer: React.FC = () => {
    const intl = useIntl();

    return (
        <DefaultFooter
            style={{
                background: 'none',
            }}
            copyright={intl.formatMessage({id: 'component.footer.copyright', defaultMessage: 'Shanghai University'})}
        />
    );
};

export default Footer;
